<template>
  <div id="select-costumers">
    <div class="d-flex">
      <div class="header-title">
        <h3 class="font-weight-light">Selecionar Clientes</h3>
      </div>
      <div class="ml-auto">
        <button
          type="button"
          class="btn btn-info"
          @click="changeToSelectMode()"
        >
          <i class="fas fa-users"></i>
          Ver Cadastrados
        </button>
      </div>
    </div>
    <loading-data v-if="isLoading"></loading-data>
    <div v-else class="card table-responsive">
      <datatable-select-customers
        :unityId="unityId"
        :periodId="periodId"
        :customers="customers"
        :columns="columns"
        :customerTypes="customerTypes"
        @reloadCustomers="getCustomers"
        @changeToSelectMode="changeToSelectMode"
      ></datatable-select-customers>
    </div>
  </div>
</template>
<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import { dateTimeSqlToDateTimeBR } from '@/utils/date'
import { typeStickTranslate } from '@/utils/statusesTranslator'
import 'datatables.net-dt/js/dataTables.dataTables'
import '@/utils/basicDataTableExtend'
import DatatableSelectCustomers from '@/components/period/DatatableSelectCustomers.vue'

export default {
  name: 'SelectCustomers',

  components: {
    LoadingData,
    DatatableSelectCustomers,
  },

  props: {
    unityId: {
      type: Number,
      required: true,
    },
    periodId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isLoading: true,
      customers: [],
      columns: [],
      customerTypes: [],
      dataTable: {
        id: 'dataTableListCustomers',
        columnDefs: [
          {
            orderable: false,
            width: 130,
            targets: [5],
          },
        ],
      },
    }
  },

  computed: {},

  methods: {
    async getCustomers() {
      try {
        this.isLoading = true
        const response = await this.$store.dispatch('getCustomers', {
          unityId: this.unityId,
          periodId: this.periodId,
        })
        if (response) {
          this.customers = response.customers
          this.columns = response.columns
          this.customerTypes = response.customerTypes
        }
        this.createDataTable()
        this.isLoading = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
    changeToSelectMode() {
      this.$emit('selectCostumersAgain', false)
    },
    createDataTable() {
      window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
      })
    },
  },

  watch: {
    unityId: {
      handler(newVal, oldVal) {
        if (newVal !== '') {
          this.getCustomers()
        }
      },
    },
  },

  mounted() {
    if (this.unityId && this.periodId) {
      this.getCustomers()
    }
  },
}
</script>
